import {
  LAYOUT_COMPONENT_TYPE,
  type LayoutBlock,
  type LayoutComponentType,
} from '@web-studio/shared-schemas';
import { footerStandardDefault } from './footer';
import { heroEditorialDefault, heroEditorialLongHeadline } from './hero';
import { heroVideoAtmosphereDefault } from './heroVideo';
import { heroReelFadeDefault } from './heroReel';
import { heroCounterBleedDefault } from './heroCounterBleed';
import { chefStoryBlockDefault, chefStoryNotesDefault } from './chefStory';
import { kitchenTeamLeadDefault } from './kitchenTeam';
import {
  imageGalleryFilmstripDefault,
  imageGalleryLedgerDefault,
  imageGalleryMasonryDefault,
  imageGalleryMosaicDefault,
  imageGallerySpotlightDefault,
} from './imageGallery';
import { dynamicMenuFlowDefault } from './dynamicMenu';
import { menuGrid3ColumnDefault } from './menu';
import {
  menuCategoryGalleryDefault,
  menuDishCardsDefault,
  menuEditorialBoardDefault,
  menuPdfCardDefault,
  menuStreetBoardDefault,
} from './menuVariants';
import { navigationHeaderDefault } from './navigation';
import {
  reservationCallBookDefault,
  reservationFormEmbedDefault,
  reservationMessengerBookDefault,
  reservationThirdPartyBookDefault,
} from './reservationForm';
import {
  tastingMenuCourseTimelineDefault,
  tastingMenuCourseTimelineSushi,
  tastingMenuPairingCardsDefault,
} from './tastingTimeline';
import { allergyCaptureSecureFormDefault } from './allergyForm';
import { simpleOpeningHoursDefault } from './openingHours';
import { addressMapBlockDefault } from './addressMap';
import { drinksListStaticDefault, drinksListCellarDefault, drinksListSheetDefault } from './drinksList';
import { staticLocationTextDefault } from './staticLocation';
import { simpleMenuStripDefault } from './simpleMenuStrip';
import { liveBakeryCounterListDefault } from './bakeryCounter';
import { socialFeedGridDefault } from './socialFeed';
import { coffeeSubscriptionMatrixDefault } from './coffeeSubscription';
import { preOrderPickupFormDefault } from './preOrderPickup';
import { dynamicCocktailSpotlightDefault } from './cocktailSpotlight';
import {
  privatePartyInquiryFormDefault,
  privatePartyInquirySalonDefault,
} from './partyInquiry';
import { liveTapListSyncDefault } from './tapList';
import { vipTableBookingStripDefault } from './vipStrip';
import { weeklyScheduleRouteStripDefault } from './weekSchedule';
import { cateringInquiryFormDefault } from './cateringInquiry';
import { faqAccordionDefault, faqLedgerDefault } from './faq';
import { liveGpsLocationEmbedDefault } from './liveGps';
import { popUpTicketPurchaseCardDefault } from './popupTicket';
import { contactBlockDefault, contactDeskDefault, contactLedgerDefault, contactThresholdDefault } from './contact';
import { announcementBarBandDefault } from './announcementBar';
import {
  backToTopCornerDefault,
  backToTopPillDefault,
  contactChannelsFabDefault,
  contactChannelsRailDefault,
  utilityBarCarouselDefault,
  utilityBarCollapseDefault,
  utilityBarStaticDefault,
  utilityBarStickyDefault,
} from './floatChrome';

export { chefStoryBlockDefault, chefStoryNotesDefault } from './chefStory';
export { kitchenTeamLeadDefault } from './kitchenTeam';
export {
  imageGalleryFilmstripDefault,
  imageGalleryLedgerDefault,
  imageGalleryMasonryDefault,
  imageGalleryMosaicDefault,
  imageGallerySpotlightDefault,
} from './imageGallery';
export { dynamicMenuFlowDefault } from './dynamicMenu';
export { footerStandardDefault } from './footer';
export { heroEditorialDefault, heroEditorialLongHeadline } from './hero';
export { heroVideoAtmosphereDefault } from './heroVideo';
export { heroReelFadeDefault } from './heroReel';
export { heroCounterBleedDefault } from './heroCounterBleed';
export { menuGrid3ColumnDefault } from './menu';
export {
  menuCategoryGalleryDefault,
  menuDishCardsDefault,
  menuEditorialBoardDefault,
  menuPdfCardDefault,
  menuStreetBoardDefault,
} from './menuVariants';
export { navigationHeaderDefault } from './navigation';
export {
  reservationCallBookDefault,
  reservationFormEmbedDefault,
  reservationMessengerBookDefault,
  reservationThirdPartyBookDefault,
} from './reservationForm';
export {
  tastingMenuCourseTimelineDefault,
  tastingMenuCourseTimelineSushi,
  tastingMenuPairingCardsDefault,
} from './tastingTimeline';
export { allergyCaptureSecureFormDefault } from './allergyForm';
export { simpleOpeningHoursDefault } from './openingHours';
export { addressMapBlockDefault } from './addressMap';
export { drinksListStaticDefault, drinksListCellarDefault, drinksListSheetDefault } from './drinksList';
export { staticLocationTextDefault } from './staticLocation';
export { simpleMenuStripDefault } from './simpleMenuStrip';
export { liveBakeryCounterListDefault } from './bakeryCounter';
export { socialFeedGridDefault } from './socialFeed';
export { coffeeSubscriptionMatrixDefault } from './coffeeSubscription';
export { preOrderPickupFormDefault } from './preOrderPickup';
export { dynamicCocktailSpotlightDefault } from './cocktailSpotlight';
export { privatePartyInquiryFormDefault, privatePartyInquirySalonDefault } from './partyInquiry';
export { liveTapListSyncDefault } from './tapList';
export { vipTableBookingStripDefault } from './vipStrip';
export { weeklyScheduleRouteStripDefault } from './weekSchedule';
export { cateringInquiryFormDefault } from './cateringInquiry';
export { faqAccordionDefault, faqLedgerDefault } from './faq';
export { liveGpsLocationEmbedDefault } from './liveGps';
export { popUpTicketPurchaseCardDefault } from './popupTicket';
export { contactBlockDefault, contactDeskDefault, contactLedgerDefault, contactThresholdDefault } from './contact';

export interface BlockFixtureDefinition {
  id: string;
  label: string;
  componentType: LayoutComponentType;
  block: LayoutBlock;
}

export const BLOCK_FIXTURES: BlockFixtureDefinition[] = [
  {
    id: 'navigation-default',
    label: 'Navigation / default',
    componentType: LAYOUT_COMPONENT_TYPE.navigationHeader,
    block: navigationHeaderDefault,
  },
  {
    id: 'hero-default',
    label: 'Hero / default',
    componentType: LAYOUT_COMPONENT_TYPE.heroEditorialSplit,
    block: heroEditorialDefault,
  },
  {
    id: 'hero-long-headline',
    label: 'Hero / long headline stress',
    componentType: LAYOUT_COMPONENT_TYPE.heroEditorialSplit,
    block: heroEditorialLongHeadline,
  },
  {
    id: 'menu-default',
    label: 'Menu grid / default',
    componentType: LAYOUT_COMPONENT_TYPE.menuGrid3Column,
    block: menuGrid3ColumnDefault,
  },
  {
    id: 'menu-pdf-card',
    label: 'Menu / PDF card',
    componentType: LAYOUT_COMPONENT_TYPE.menuGrid3Column,
    block: menuPdfCardDefault,
  },
  {
    id: 'menu-category-gallery',
    label: 'Menu / category gallery',
    componentType: LAYOUT_COMPONENT_TYPE.menuGrid3Column,
    block: menuCategoryGalleryDefault,
  },
  {
    id: 'menu-dish-cards',
    label: 'Menu / dish cards',
    componentType: LAYOUT_COMPONENT_TYPE.menuGrid3Column,
    block: menuDishCardsDefault,
  },
  {
    id: 'menu-editorial-board',
    label: 'Menu / editorial board',
    componentType: LAYOUT_COMPONENT_TYPE.menuGrid3Column,
    block: menuEditorialBoardDefault,
  },
  {
    id: 'menu-street-board',
    label: 'Menu / street board',
    componentType: LAYOUT_COMPONENT_TYPE.menuGrid3Column,
    block: menuStreetBoardDefault,
  },
  {
    id: 'dynamic-menu-default',
    label: 'Dynamic menu / tabbed',
    componentType: LAYOUT_COMPONENT_TYPE.dynamicMenuFlow,
    block: dynamicMenuFlowDefault,
  },
  {
    id: 'reservation-form-default',
    label: 'Reservation / inquiry form',
    componentType: LAYOUT_COMPONENT_TYPE.reservationFormEmbed,
    block: reservationFormEmbedDefault,
  },
  {
    id: 'reservation-third-party-default',
    label: 'Reservation / third-party book',
    componentType: LAYOUT_COMPONENT_TYPE.reservationThirdPartyBook,
    block: reservationThirdPartyBookDefault,
  },
  {
    id: 'reservation-messenger-default',
    label: 'Reservation / messenger book',
    componentType: LAYOUT_COMPONENT_TYPE.reservationMessengerBook,
    block: reservationMessengerBookDefault,
  },
  {
    id: 'reservation-call-default',
    label: 'Reservation / call book',
    componentType: LAYOUT_COMPONENT_TYPE.reservationCallBook,
    block: reservationCallBookDefault,
  },
  {
    id: 'chef-story-default',
    label: 'Chef story / default',
    componentType: LAYOUT_COMPONENT_TYPE.chefStoryBlock,
    block: chefStoryBlockDefault,
  },
  {
    id: 'chef-story-notes',
    label: 'Chef story / notes',
    componentType: LAYOUT_COMPONENT_TYPE.chefStoryBlock,
    block: chefStoryNotesDefault,
  },
  {
    id: 'kitchen-team-lead',
    label: 'Kitchen team / lead',
    componentType: LAYOUT_COMPONENT_TYPE.kitchenTeamBlock,
    block: kitchenTeamLeadDefault,
  },
  {
    id: 'image-gallery-default',
    label: 'Gallery / mosaic',
    componentType: LAYOUT_COMPONENT_TYPE.imageGallery,
    block: imageGalleryMosaicDefault,
  },
  {
    id: 'image-gallery-masonry',
    label: 'Gallery / masonry',
    componentType: LAYOUT_COMPONENT_TYPE.imageGallery,
    block: imageGalleryMasonryDefault,
  },
  {
    id: 'image-gallery-filmstrip',
    label: 'Gallery / filmstrip',
    componentType: LAYOUT_COMPONENT_TYPE.imageGallery,
    block: imageGalleryFilmstripDefault,
  },
  {
    id: 'image-gallery-spotlight',
    label: 'Gallery / spotlight',
    componentType: LAYOUT_COMPONENT_TYPE.imageGallery,
    block: imageGallerySpotlightDefault,
  },
  {
    id: 'image-gallery-ledger',
    label: 'Gallery / ledger',
    componentType: LAYOUT_COMPONENT_TYPE.imageGallery,
    block: imageGalleryLedgerDefault,
  },
  {
    id: 'tasting-timeline-default',
    label: 'Tasting timeline / default',
    componentType: LAYOUT_COMPONENT_TYPE.tastingMenuCourseTimeline,
    block: tastingMenuCourseTimelineDefault,
  },
  {
    id: 'tasting-timeline-sushi',
    label: 'Tasting timeline / Hinoki Omakase photos',
    componentType: LAYOUT_COMPONENT_TYPE.tastingMenuCourseTimeline,
    block: tastingMenuCourseTimelineSushi,
  },
  {
    id: 'tasting-pairing-cards',
    label: 'Tasting / pairing cards',
    componentType: LAYOUT_COMPONENT_TYPE.tastingMenuCourseTimeline,
    block: tastingMenuPairingCardsDefault,
  },
  {
    id: 'allergy-form-default',
    label: 'Allergy form / default',
    componentType: LAYOUT_COMPONENT_TYPE.allergyCaptureSecureForm,
    block: allergyCaptureSecureFormDefault,
  },
  {
    id: 'hero-video-default',
    label: 'Hero video / default',
    componentType: LAYOUT_COMPONENT_TYPE.heroVideoAtmosphere,
    block: heroVideoAtmosphereDefault,
  },
  {
    id: 'hero-reel-fade-default',
    label: 'Hero reel fade / default',
    componentType: LAYOUT_COMPONENT_TYPE.heroEditorialSplit,
    block: heroReelFadeDefault,
  },
  {
    id: 'hero-counter-bleed-default',
    label: 'Hero counter bleed / default',
    componentType: LAYOUT_COMPONENT_TYPE.heroEditorialSplit,
    block: heroCounterBleedDefault,
  },
  {
    id: 'footer-default',
    label: 'Footer / default',
    componentType: LAYOUT_COMPONENT_TYPE.footerStandard,
    block: footerStandardDefault,
  },
  {
    id: 'opening-hours-default',
    label: 'Opening hours / default',
    componentType: LAYOUT_COMPONENT_TYPE.simpleOpeningHours,
    block: simpleOpeningHoursDefault,
  },
  {
    id: 'address-map-default',
    label: 'Address map / default',
    componentType: LAYOUT_COMPONENT_TYPE.addressMapBlock,
    block: addressMapBlockDefault,
  },
  {
    id: 'drinks-list-default',
    label: 'Drinks list / default',
    componentType: LAYOUT_COMPONENT_TYPE.drinksListStatic,
    block: drinksListStaticDefault,
  },
  {
    id: 'drinks-list-cellar',
    label: 'Drinks list / cellar',
    componentType: LAYOUT_COMPONENT_TYPE.drinksListStatic,
    block: drinksListCellarDefault,
  },
  {
    id: 'drinks-list-sheet',
    label: 'Drinks list / wine sheet',
    componentType: LAYOUT_COMPONENT_TYPE.drinksListStatic,
    block: drinksListSheetDefault,
  },
  {
    id: 'static-location-default',
    label: 'Static location / default',
    componentType: LAYOUT_COMPONENT_TYPE.staticLocationText,
    block: staticLocationTextDefault,
  },
  {
    id: 'simple-menu-strip-default',
    label: 'Simple menu strip / default',
    componentType: LAYOUT_COMPONENT_TYPE.simpleMenuStrip,
    block: simpleMenuStripDefault,
  },
  {
    id: 'bakery-counter-default',
    label: 'Bakery counter / default',
    componentType: LAYOUT_COMPONENT_TYPE.liveBakeryCounterList,
    block: liveBakeryCounterListDefault,
  },
  {
    id: 'social-feed-default',
    label: 'Social feed / default',
    componentType: LAYOUT_COMPONENT_TYPE.socialFeedGrid,
    block: socialFeedGridDefault,
  },
  {
    id: 'coffee-subscription-default',
    label: 'Coffee subscription / default',
    componentType: LAYOUT_COMPONENT_TYPE.coffeeSubscriptionMatrix,
    block: coffeeSubscriptionMatrixDefault,
  },
  {
    id: 'preorder-pickup-default',
    label: 'Pre-order pickup / default',
    componentType: LAYOUT_COMPONENT_TYPE.preOrderPickupForm,
    block: preOrderPickupFormDefault,
  },
  {
    id: 'cocktail-spotlight-default',
    label: 'Cocktail spotlight / default',
    componentType: LAYOUT_COMPONENT_TYPE.dynamicCocktailSpotlight,
    block: dynamicCocktailSpotlightDefault,
  },
  {
    id: 'party-inquiry-default',
    label: 'Party inquiry / default',
    componentType: LAYOUT_COMPONENT_TYPE.privatePartyInquiryForm,
    block: privatePartyInquiryFormDefault,
  },
  {
    id: 'party-inquiry-salon',
    label: 'Party inquiry / salon',
    componentType: LAYOUT_COMPONENT_TYPE.privatePartyInquiryForm,
    block: privatePartyInquirySalonDefault,
  },
  {
    id: 'tap-list-default',
    label: 'Tap list / default',
    componentType: LAYOUT_COMPONENT_TYPE.liveTapListSync,
    block: liveTapListSyncDefault,
  },
  {
    id: 'vip-strip-default',
    label: 'VIP strip / default',
    componentType: LAYOUT_COMPONENT_TYPE.vipTableBookingStrip,
    block: vipTableBookingStripDefault,
  },
  {
    id: 'week-schedule-default',
    label: 'Week schedule / default',
    componentType: LAYOUT_COMPONENT_TYPE.weeklyScheduleRouteStrip,
    block: weeklyScheduleRouteStripDefault,
  },
  {
    id: 'catering-inquiry-default',
    label: 'Catering inquiry / default',
    componentType: LAYOUT_COMPONENT_TYPE.cateringInquiryForm,
    block: cateringInquiryFormDefault,
  },
  {
    id: 'faq-default',
    label: 'FAQ / Accordion',
    componentType: LAYOUT_COMPONENT_TYPE.faqBlock,
    block: faqAccordionDefault,
  },
  {
    id: 'faq-ledger',
    label: 'FAQ / Ledger',
    componentType: LAYOUT_COMPONENT_TYPE.faqBlock,
    block: faqLedgerDefault,
  },
  {
    id: 'live-gps-default',
    label: 'Live GPS / default',
    componentType: LAYOUT_COMPONENT_TYPE.liveGpsLocationEmbed,
    block: liveGpsLocationEmbedDefault,
  },
  {
    id: 'popup-ticket-default',
    label: 'Pop-up ticket / default',
    componentType: LAYOUT_COMPONENT_TYPE.popUpTicketPurchaseCard,
    block: popUpTicketPurchaseCardDefault,
  },
  {
    id: 'contact-default',
    label: 'Contact / Visit',
    componentType: LAYOUT_COMPONENT_TYPE.contactBlock,
    block: contactBlockDefault,
  },
  {
    id: 'contact-desk',
    label: 'Contact / Desk',
    componentType: LAYOUT_COMPONENT_TYPE.contactBlock,
    block: contactDeskDefault,
  },
  {
    id: 'contact-ledger',
    label: 'Contact / Ledger',
    componentType: LAYOUT_COMPONENT_TYPE.contactBlock,
    block: contactLedgerDefault,
  },
  {
    id: 'contact-threshold',
    label: 'Contact / Threshold',
    componentType: LAYOUT_COMPONENT_TYPE.contactBlock,
    block: contactThresholdDefault,
  },
  {
    id: 'back-to-top-default',
    label: 'Back to top / Corner disc',
    componentType: LAYOUT_COMPONENT_TYPE.backToTopFloat,
    block: backToTopCornerDefault,
  },
  {
    id: 'back-to-top-pill',
    label: 'Back to top / Transparent icon',
    componentType: LAYOUT_COMPONENT_TYPE.backToTopFloat,
    block: backToTopPillDefault,
  },
  {
    id: 'contact-channels-default',
    label: 'Contact channels / Rail',
    componentType: LAYOUT_COMPONENT_TYPE.contactChannelsFloat,
    block: contactChannelsRailDefault,
  },
  {
    id: 'contact-channels-fab',
    label: 'Contact channels / Fab',
    componentType: LAYOUT_COMPONENT_TYPE.contactChannelsFloat,
    block: contactChannelsFabDefault,
  },
  {
    id: 'utility-bar-default',
    label: 'Utility bar / Sticky',
    componentType: LAYOUT_COMPONENT_TYPE.utilityBar,
    block: utilityBarStickyDefault,
  },
  {
    id: 'utility-bar-static',
    label: 'Utility bar / Static',
    componentType: LAYOUT_COMPONENT_TYPE.utilityBar,
    block: utilityBarStaticDefault,
  },
  {
    id: 'utility-bar-carousel',
    label: 'Utility bar / Carousel',
    componentType: LAYOUT_COMPONENT_TYPE.utilityBar,
    block: utilityBarCarouselDefault,
  },
  {
    id: 'utility-bar-collapse',
    label: 'Utility bar / Collapse',
    componentType: LAYOUT_COMPONENT_TYPE.utilityBar,
    block: utilityBarCollapseDefault,
  },
  {
    id: 'announcement-bar-default',
    label: 'Announcement bar / Band',
    componentType: LAYOUT_COMPONENT_TYPE.announcementBar,
    block: announcementBarBandDefault,
  },
];

export function getBlockFixture(fixtureId: string): BlockFixtureDefinition | undefined {
  return BLOCK_FIXTURES.find((f) => f.id === fixtureId);
}

export function getDefaultFixtureForComponent(
  componentType: LayoutComponentType,
): BlockFixtureDefinition | undefined {
  return BLOCK_FIXTURES.find((f) => f.componentType === componentType && f.id.endsWith('-default'));
}
